/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Scheduled/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Scheduled({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/Time/Scheduled"
  
}) {
let eventAppointmentBooking0LocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].local_start_date',
})
let eventAppointmentBooking0LocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].local_start_time',
})
let eventAppointmentDurationValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.duration',
})
let aggregateData = fromFormat.dateFormatRelativeDisplay(eventAppointmentBooking0LocalStartDateValueData, eventAppointmentBooking0LocalStartTimeValueData, eventAppointmentDurationValueData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 size="small"
 data="event.appointment.booking.[0].local_start_date"
 data="event.appointment.booking.[0].local_start_time"
 data="event.appointment.duration"
 aggregate="/Data/format.js dateFormatRelativeDisplay"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}